<div class="enter-balances-table-container container-fluid">
  <div class="row deal-number-or-cusip-container">
    <div class="col-md-6 deal-number-container">
      <div class="deal-number">Deal Number</div>
      <div class="deal-number-or-cusip">{{ dealNumberOrCusip }}</div>
    </div>
    <div class="col-md-6 prospectus-supplement-container">
      <div class="prospectus-link">See prospectus supplement</div>
      <div class="prospectus-link">See previous exchanges in this deal</div>
    </div>
  </div>

  <div class="col-md-4 available-recombination-text">Available Recombinations</div>
  <div class="col-md-8 toolbar-actions">
    <button type="button"><i class="fa fa-sliders table-action-icon"></i>Customize View</button>
    <button type="button"><i class="fa fa-rss table-action-icon"></i>Filter</button>
    <button type="button"><i class="fa fa-search table-action-icon"></i>Search</button>
  </div>

  <invd-smbs-exchange-table
    [smbsRecombinationExchanges]="expdleSmbsExchangeResponse"
    class="smbs-exchange-table"
  >
  </invd-smbs-exchange-table>
</div>
